import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import { Colors } from "./styles/Colors";
import { Header4, ProximaNova } from "./typography";
import Breakpoints from "./styles/Breakpoints";
import { Link } from "gatsby";

const Wrapper = styled.div`
  max-width: 480px;
  width: 90%;

  text-decoration: none;

  color: inherit;

  .gatsby-image-wrapper {
    max-width: 100%;
  }

  ${Header4} {
    margin-top: 20px;
  }

  @media ${Breakpoints.tablet} {
    max-width: 640px;
  }
`;

const AuthorText = styled.p`
  font-family: ${ProximaNova};
  font-size: 12px;
  line-height: 133.5%;

  color: ${Colors.cream1};
`;

function slugify(str) {
  return str
    ?.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[-]+/g, "-")
    .replace(/[^\w-]+/g, "");
}

export default function BlogCard({ post }) {
  return (
    <Wrapper
      as={Link}
      to={`/blog/${slugify(post.category.headline)}/${post.slug}`}
    >
      <Image fixed={post.image.fixed} />
      {/* <AuthorText>By John Doe on 6.1.2020</AuthorText> */}
      <Header4>{post.title}</Header4>
    </Wrapper>
  );
}
